module.exports = __webpack_public_path__ + "static/media/tlyfe-video-mock-mobile.1e762554.png";